import { render, staticRenderFns } from "./HotspotRichmedia.vue?vue&type=template&id=13e7ab36&scoped=true&"
import script from "./HotspotRichmedia.vue?vue&type=script&lang=js&"
export * from "./HotspotRichmedia.vue?vue&type=script&lang=js&"
import style0 from "./HotspotRichmedia.vue?vue&type=style&index=0&id=13e7ab36&prod&scoped=true&lang=scss&"
import style1 from "./HotspotRichmedia.vue?vue&type=style&index=1&id=13e7ab36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e7ab36",
  null
  
)

export default component.exports